import mapValues from 'lodash.mapvalues';

// Global Types
import {
    MyTimesheetEntry,
    MyTimesheetEntries
} from 'services/myTimesheetEntries/types';

// Global Utils
import {
    calculateWorkPeriodMinutes,
    calculateTotalPaidMinutes,
    calculateEarnings,
    calculateEffectiveRate
} from 'utils/timesheets';
import calculateMinimumRestAndMealBreaks from 'utils/minimum-breaks';

const formatMyTimesheetEntry = (
    myTimesheetEntry: MyTimesheetEntry
): MyTimesheetEntry => {
    const {
        endTime,
        hasEditedPaidBreak,
        hasEditedUnpaidBreak,
        paidBreakMinutes,
        rate,
        startTime,
        units,
        unpaidBreakMinutes
    } = myTimesheetEntry;

    const totalPaidMinutes = calculateTotalPaidMinutes({
        endTime,
        startTime,
        unpaidBreakMinutes
    });

    const earnings = calculateEarnings({
        units,
        rate
    });

    const effectiveRate = calculateEffectiveRate({
        earnings,
        totalPieceRateHours: totalPaidMinutes / 60
    });

    const workPeriodMinutes = calculateWorkPeriodMinutes({
        startTime,
        endTime
    });

    const {
        totalMealBreaksMinutes,
        totalRestBreaksMinutes
    } = calculateMinimumRestAndMealBreaks(workPeriodMinutes);

    return {
        ...myTimesheetEntry,
        totalPaidMinutes,
        earnings: earnings || null,
        effectiveRate: effectiveRate || null,
        paidBreakMinutes: hasEditedPaidBreak
            ? paidBreakMinutes
            : totalRestBreaksMinutes || null,
        unpaidBreakMinutes: hasEditedUnpaidBreak
            ? unpaidBreakMinutes
            : totalMealBreaksMinutes || null
    };
};

const formatMyTimesheetEntries = (
    myTimesheetEntries: MyTimesheetEntries
): MyTimesheetEntries => {
    return mapValues(myTimesheetEntries, (myTimesheetEntry: MyTimesheetEntry) =>
        formatMyTimesheetEntry(myTimesheetEntry)
    );
};

export { formatMyTimesheetEntry, formatMyTimesheetEntries };
